/**
 * Labels Hook
 *
 * Fetches and manages label data from the API via TanStack Query.
 */

import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getLabels } from '../api/client';

export const useLabels = () => {
  const {
    data: labels = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['labels'],
    queryFn: getLabels,
  });

  const labelNames = useMemo(() => labels.map((l) => l.name), [labels]);

  return {
    labels,
    labelNames,
    isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to fetch labels') : null,
    refetch,
  };
};
